'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Checkbox = require('../../Checkbox/src/Checkbox.js');
var Radio = require('../../Radio/src/Radio.js');
var Space = require('../../Space/src/Space.js');
var Switch = require('../../Switch/src/Switch.js');
var Menu_module = require('../styles/Menu.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const ChildrenWrapper = (args) => {
    const { children, ...props } = args;
    return React__namespace.cloneElement(children, props);
};
/**
 * @description Menu Item component.
 *
 * @component
 * @example
 * ```jsx
 * <Menu.Item hint="hint">Content</Menu.Item>
 * ```
 */
const MenuItem = React__namespace.forwardRef((props, ref) => {
    const { value, icon, control, hint, description, active, disabled, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Menu_module.default);
    const classNames = cx(className, 'item-base', 'item', {
        active,
        disabled,
    });
    const iconClassNames = cx(className, 'icon', {
        disabled,
    });
    const controlClassNames = cx(className, 'control', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'control-indent': description || icon,
        disabled,
    });
    const descriptionClassNames = cx(className, 'description', {
        disabled,
    });
    const controlElement = React__namespace.useMemo(() => {
        // @ts-ignore
        if (control && (control.type === Radio.Radio || control.type === Checkbox.Checkbox || control.type === Switch.Switch)) {
            const inputProps = {
                value,
                disabled,
                checked: active,
                readOnly: true,
            };
            return React__namespace.createElement(ChildrenWrapper, { ...inputProps }, control);
        }
        return control;
    }, [control, value, disabled, active]);
    return (React__namespace.createElement(Space.Space, { ref: ref, align: "center", size: 12, className: classNames, ...restProps },
        icon && React__namespace.createElement("div", { className: iconClassNames }, icon),
        React__namespace.createElement(Space.Space, { direction: "vertical", align: "start", size: 0 },
            hint && React__namespace.createElement("div", { className: descriptionClassNames }, hint),
            React__namespace.createElement("div", { className: cx('text') }, children),
            description && React__namespace.createElement("div", { className: descriptionClassNames }, description)),
        control && React__namespace.createElement("div", { className: controlClassNames }, controlElement)));
});
MenuItem.defaultProps = {};
MenuItem.displayName = 'MenuItem';

exports.MenuItem = MenuItem;
//# sourceMappingURL=MenuItem.js.map
